// import external dependencies
import 'jquery';

// Import everything from autoload


// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';

// Additional Libraries
import { close_menu, setup_menu_trigger, setup_contactmenu_trigger } from './modules/menu';
import { init_scroll_hint, toggle_alternate_header } from './modules/hero-with-form-widget';
import { rerun_gravity_forms_scripts, rerun_embbeded_blogpost_scripts } from './modules/forms';
import 'lazysizes';

// Swup setup
// import Swup from 'swup';
// import SwupBodyClassPlugin from '@swup/body-class-plugin';
// import SwupScrollPlugin from '@swup/scroll-plugin';
import GlobalMeasurements from './modules/global-measurements';
import GridVisualiser from './modules/grid-visualiser';
import Masthead from './modules/masthead';
// import BoneCustomSwupUpdater from './modules/bone-custom-swup-updater';
// import CookieBanner from './modules/cookie-banner';
/*
const options = {
	linkSelector: `a[href^="${window.location.origin}"]:not([data-no-swup]):not([target="_blank"]), a[href^="/"]:not([data-no-swup]):not([target="_blank"]), a[href^="#"]:not([data-no-swup]):not([target="_blank"])`,
	plugins: [
		// new SwupBodyClassPlugin(),
		new SwupScrollPlugin({
			doScrollingRightAway: false,
			animateScroll: false,
		}),
		new BoneCustomSwupUpdater(),
	],
	animateHistoryBrowsing: true,
	containers: [
		'#body-wrapper',
		'.masthead__callout-bar',
		'.masthead__nav',
		'.lang-modal-content',
		'.footer__layout',
		'.mobilemenu__scroll-container',
		'.find-location-modal-content__scroll-container',
	],
};
const swup = new Swup(options);
window.swup = swup;
*/
/** Populate Router instance with DOM routes */
const routes = new Router({
	// All pages
	common,
	// Home page
	home,
});

// Generic events - these are loaded once only and would not re-run on Swup page changes
jQuery(document).ready(() => {
	// Place one off code here - such as click events for the menu
	setup_menu_trigger();
	setup_contactmenu_trigger();
	init_scroll_hint();
	toggle_alternate_header();
	GlobalMeasurements.start();
	GridVisualiser.init();
	Masthead.init();
	// CookieBanner.init();
});

// Load Events
jQuery(document).on('ready', () => routes.loadEvents());
/*
// Load Events when using Swup
swup.on('contentReplaced', () => {
	rerun_embbeded_blogpost_scripts();
	setup_menu_trigger();
	close_menu();
	routes.loadEvents();
	Masthead.init();
});
*/



// WEBPACK FOOTER //
// ./scripts/main.js